<template>
  <div class="panel">
    <h2> {{location.name}} </h2>
    <p class='address' >
      <a target="_blank" v-if="location.show_address" :href="address">
        <span v-show="location.show_address">{{ location.address }}</span>
      <span v-if="location.address2 && location.show_address">
        <br/> {{ location.address2 }}
      </span>
      <br/> {{location.city}} , {{location.state}} {{location.zip}}</a>
      <span v-else>
        {{location.city}} , {{location.state}} {{location.zip}}
      </span>

      <br/> <a class='phone' :href="local_phone"> {{location.local_phone}} </a>
      <br/><span class="distance" v-if="location.distance" v-text="location.distance.toFixed(2) + ` miles.`"></span>
    </p>
    <a class='yellow-bttn' :href="location.link" @click.prevent="visitURL">View Website </a>
  </div>
</template>

<script>
  export default {
    name:     "Location",
    props:    ["location"],
    computed: {
      local_phone() {
        return "tel:" + this.location.local_phone;
      },
      address(){
        return this.location.show_address ? "https://maps.google.com/?q=" + this.location.address + ', ' + this.location.city + ', ' + this.location.state + ', ' + this.location.zip:'';
      }
    },
    methods:  {

      visitURL() {
        let url = `${ googlemap_deps.domain }/wp-json/public/v1/update-location/${ this.location.id }`;

        $.ajax( url )
         .done( res => {
           if ( res ) {
             window.location.replace( res );
           } else {
             window.location.replace( this.location.link );
           }
         } )
         .fail( r => {
           window.location.replace( this.location.link );
         } );
      },
    },
  };
</script>

<style scoped>

</style>
